module.exports = __webpack_public_path__ + "img/Lucky5_Express.ba23236c.png";